import React, { useEffect, useState } from 'react';
import './visitantes.css';
import { useInternals } from '../../context/internalContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { toast } from 'react-toastify';
import FormattedInput from '../../components/FormatdInput/formatFunctions';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import api from '../../services/api';
import TooltipInfo from '../../components/TooltipInfo';
import { useUsers } from '../../context/usersContext';
import CadastroMenorForm from './cadastroMenorForm';

const steps = [
  { id: 1, label: 'Informações Pessoais' },
  { id: 2, label: 'Internos Associados' },
  { id: 3, label: 'Endereço' },
  { id: 4, label: 'Documentos' },
  { id: 5, label: 'Declaração' },
  { id: 6, label: 'Confirmação' },
];


const formatDateForInput = (value) => {
  if (!value) return '';
  const stringValue = String(value);
  return stringValue.includes('T') ? stringValue.split('T')[0] : stringValue;
};

const CadastroVisitante = () => {
  const { listInternals } = useInternals();
  const { listTypeRelationInternal, listCity, listState } = useAuxiliaries();
  const { buildUnitReadParams } = useUsers();

  const [errors, setErrors] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [filteredInternals, setFilteredInternals] = useState([]);
  const [selectedInternal, setSelectedInternal] = useState(null);
  const [relationTypes, setRelationTypes] = useState([]);
  const [states, setStates] = useState([]);
  const [stateSearchQuery, setStateSearchQuery] = useState('');
  const [citySearchQuery, setCitySearchQuery] = useState('');
  const [filteredStates, setFilteredStates] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [shouldSearchState, setShouldSearchState] = useState(false);
  const [shouldSearchCity, setShouldSearchCity] = useState(false);
  const [addedInternals, setAddedInternals] = useState([]);
  const [registrationMode, setRegistrationMode] = useState('visitor');

  const normalizeText = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();


  const [formData, setFormData] = useState({
    name: '',
    cpf: '',
    email: '',
    phone_one: '',
    phone_second: '',
    rules: false,
    date_of_birth: '',
    nationality: '',
    naturalness: '',
    internal: '',
    intcpf: '',
    type_relationship: '',
    intdate_of_birth: '',
    mother: '',
    city: '',
    uf: '',
    neighborhood: '',
    public_place: '',
    'Foto 3X4': null,
    'Cedula de identidade ou documento equivalente': null,
    'Cadastro de Pessoa Física (CPF)': null,
    'Certidão de antecedentes criminais estadual': null,
    'Certidão de antecedentes criminais federal': null,
    'Comprovante de residência': null,
    'Certidão de casamento': null,
    'Declaração união estável': null,
    'Prova de mesmo domicílio': null,
    'Outros documentos de comprovação de união': null,
  });

  // Função para avançar para o próximo step com validação
  const nextStep = () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length === 0) {
      setCurrentStep(currentStep + 1);
    } else {
      setErrors(validationErrors);
    }
  };

  // Função para voltar para o step anterior
  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  // Carregar os tipos de relacionamento quando o componente for montado
  useEffect(() => {
    const loadRelationTypes = async () => {
      try {
        const response = await listTypeRelationInternal();
        if (Array.isArray(response)) {
          setRelationTypes(response);
        } else {
          setRelationTypes([]);
        }
      } catch (error) {
        console.error('Erro ao carregar os tipos de relacionamento:', error);
        setRelationTypes([]);
      }
    };

    const loadStates = async () => {
      try {
        const response = await listState();
        if (response && Array.isArray(response.results)) {
          setStates(response.results);
        } else {
          setStates([]);
        }
      } catch (error) {
        console.error('Erro ao carregar estados:', error);
        setStates([]);
      }
    };


    loadStates();
    loadRelationTypes();
  }, [listTypeRelationInternal, listState]);

  useEffect(() => {
    const query = stateSearchQuery.trim();
    if (!shouldSearchState || query.length < 2) {
      setFilteredStates([]);
      return;
    }

    const normalizedQuery = normalizeText(query);
    const filtered = states.filter((state) => {
      const stateName = normalizeText(state?.name || '');
      const stateUf = normalizeText(state?.uf || '');
      return stateName.includes(normalizedQuery) || stateUf.includes(normalizedQuery);
    });
    setFilteredStates(filtered);
  }, [stateSearchQuery, shouldSearchState, states]);

  useEffect(() => {
    const query = citySearchQuery.trim();
    if (!shouldSearchCity || query.length < 3 || !formData.uf) {
      setFilteredCities([]);
      return;
    }

    const debounce = setTimeout(async () => {
      try {
        const response = await listCity({ name: query });
        let cities = Array.isArray(response?.results) ? response.results : [];

        const normalizedStateName = normalizeText(stateSearchQuery);
        const normalizedUf = normalizeText(formData.uf);

        cities = cities.filter((city) => {
          const cityStateName = normalizeText(city?.state_name || city?.state || '');
          const cityStateUf = normalizeText(city?.state_uf || city?.uf || '');
          const matchesStateByName = normalizedStateName
            ? cityStateName.includes(normalizedStateName) || normalizedStateName.includes(cityStateName)
            : false;
          const matchesStateByUf = normalizedUf ? cityStateUf === normalizedUf : false;
          return matchesStateByName || matchesStateByUf;
        });

        setFilteredCities(cities);
      } catch (error) {
        console.error('Erro ao buscar cidades:', error);
        setFilteredCities([]);
      }
    }, 300);

    return () => clearTimeout(debounce);
  }, [citySearchQuery, shouldSearchCity, formData.uf, stateSearchQuery, listCity]);

  // Função para buscar internos ao digitar
  const handleInternalSearch = (e) => {
    setFormData({ ...formData, internal: e.target.value });
    setSelectedInternal(null);
  };

  // Busca com debounce: só consulta a API quando o usuário para de digitar; resposta de um termo
  // antigo que chegar atrasada é ignorada. Com interno já escolhido na lista, não busca.
  useEffect(() => {
    const query = (formData.internal || '').trim();
    if (selectedInternal || query.length < 3) {
      setFilteredInternals([]);
      return undefined;
    }

    let isCurrent = true;
    const timer = setTimeout(async () => {
      try {
        const response = await listInternals(buildUnitReadParams({
          name: query,
          limit: 10,
          offset: 0,
        }));
        const rawInternals =
          (Array.isArray(response?.results) && response.results) ||
          (Array.isArray(response?.data) && response.data) ||
          (Array.isArray(response) && response) ||
          [];

        const normalizedInternals = rawInternals
          .map((internal, index) => {
            const name = internal?.name || internal?.Nome || internal?.label || internal;
            if (!name) {
              return null;
            }
            return {
              id: internal?.id || internal?.document || `internal-${index}-${name}`,
              name,
              unit: internal?.unit || '',
              cpf: internal?.cpf || '',
              mothers_name: internal?.mothers_name || '',
              date_of_birth: formatDateForInput(internal?.date_of_birth),
            };
          })
          .filter(Boolean);

        if (isCurrent) setFilteredInternals(normalizedInternals);
      } catch (error) {
        console.error('Erro ao buscar internos:', error);
        if (isCurrent) setFilteredInternals([]);
      }
    }, 400);

    return () => {
      isCurrent = false;
      clearTimeout(timer);
    };
  }, [formData.internal, selectedInternal, listInternals, buildUnitReadParams]);

  // Função para selecionar o interno da lista
  const handleSelectInternal = (internal) => {
    setFormData((prev) => ({
      ...prev,
      internal: internal.name || '',
      intcpf: internal.cpf || prev.intcpf,
      intdate_of_birth: internal.date_of_birth || prev.intdate_of_birth,
      mother: internal.mothers_name || prev.mother,
    }));
    setSelectedInternal(internal);
    setFilteredInternals([]);
  };

  // Função para lidar com a mudança de dados do formulário
  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value,
    });
  };

  const handleStateSearch = (query) => {
    setStateSearchQuery(query);
    setShouldSearchState(true);
    setFormData((prev) => ({
      ...prev,
      uf: '',
      city: '',
    }));
    setCitySearchQuery('');
    setFilteredCities([]);
    setShouldSearchCity(false);
  };

  const selectState = (state) => {
    const stateName = state?.name || state?.uf || '';
    const stateUf = state?.uf || stateName;
    setFormData((prev) => ({
      ...prev,
      uf: stateUf,
      city: '',
    }));
    setStateSearchQuery(stateName);
    setFilteredStates([]);
    setShouldSearchState(false);
    setCitySearchQuery('');
    setFilteredCities([]);
  };

  const handleCitySearch = (query) => {
    setCitySearchQuery(query);
    setShouldSearchCity(true);
    setFormData((prev) => ({ ...prev, city: '' }));
  };

  const selectCity = (city) => {
    const cityName = city?.name || '';
    setFormData((prev) => ({ ...prev, city: cityName }));
    setCitySearchQuery(cityName);
    setFilteredCities([]);
    setShouldSearchCity(false);
  };

  // Função de validação para os campos de cada etapa
  const validateForm = () => {
    let validationErrors = {};

    if (currentStep === 1) {
      if (!formData.name) validationErrors.name = 'Nome é obrigatório.';
      if (!formData.cpf) validationErrors.cpf = 'CPF é obrigatório.';
      if (!formData.date_of_birth) validationErrors.date_of_birth = 'Data de nascimento é obrigatória.';
      if (!formData.nationality) validationErrors.nationality = 'Nacionalidade é obrigatória.';
      if (!formData.naturalness) validationErrors.naturalness = 'Naturalidade é obrigatória.';
      if (!formData.email) validationErrors.email = 'E-mail é obrigatório.';
      if (!formData.phone_one) validationErrors.phone_one = 'Telefone é obrigatório.';
    }

    if (currentStep === 2) {
      if (addedInternals.length === 0) {
        validationErrors.internal = 'Você deve adicionar pelo menos um interno associado.';
      }
    }

    if (currentStep === 3) {
      if (!formData.city) validationErrors.city = 'Cidade é obrigatória.';
      if (!formData.uf) validationErrors.uf = 'Estado é obrigatório.';
      if (!formData.neighborhood) validationErrors.neighborhood = 'Bairro é obrigatório.';
      if (!formData.public_place) validationErrors.public_place = 'Logradouro é obrigatório.';
    }

    if (currentStep === 4) {
      if (!formData['Foto 3X4']) {
        validationErrors['Foto 3X4'] = 'Este documento é obrigatório.';
      }
      if (!formData['Cedula de identidade ou documento equivalente']) {
        validationErrors['Cedula de identidade ou documento equivalente'] = 'Este documento é obrigatório.';
      }
      if (!formData['Cadastro de Pessoa Física (CPF)']) {
        validationErrors['Cadastro de Pessoa Física (CPF)'] = 'Este documento é obrigatório.';
      }
    }

    if (currentStep === 5) {
      if (!formData.rules) validationErrors.rules = 'Você deve concordar com os termos.';
    }

    return validationErrors;
  };

  // Função para adicionar um novo interno
  const handleAddInternal = () => {
    if (!formData.internal || !formData.type_relationship || !formData.intdate_of_birth || !formData.mother) {
      toast.warning('Preencha todos os campos do interno antes de adicionar.');
      return;
    }

    const selectedName = selectedInternal?.name?.toLowerCase().trim();
    const inputName = (formData.internal || '').toLowerCase().trim();

    if (!selectedName || selectedName !== inputName) {
      toast.warning('Selecione um interno válido da lista de sugestões.');
      return;
    }

    const newInternal = {
      name: formData.internal,
      cpf: formData.intcpf,
      type_relationship: formData.type_relationship,
      date_of_birth: formData.intdate_of_birth,
      mother: formData.mother,
    };

    setAddedInternals([...addedInternals, newInternal]);
    setErrors({});
    setFormData({
      ...formData,
      internal: '',
      intcpf: '',
      type_relationship: '',
      intdate_of_birth: '',
      mother: '',
    });
    setSelectedInternal(null);
  };


  // Função para remover um interno da lista
  const handleRemoveInternal = (index) => {
    const newInternals = addedInternals.filter((_, i) => i !== index);
    setAddedInternals(newInternals);
  };

  // Função para submeter o formulário
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const data = new FormData();

    Object.keys(formData).forEach((key) => {
      if (formData[key]) {
        data.append(key, formData[key]);
        console.log(`${key}:`, formData[key]);
      }
    });

    // Adiciona o primeiro interno (sem sufixo)
    if (addedInternals.length > 0) {
      const firstInternal = addedInternals[0];
      data.append('internal', firstInternal.name);
      data.append('intcpf', firstInternal.cpf);
      data.append('type_relationship', firstInternal.type_relationship);
      data.append('intdate_of_birth', firstInternal.date_of_birth);
      data.append('mother', firstInternal.mother);
    }

    // Adiciona os internos subsequentes com sufixos (a partir do 1)
    addedInternals.slice(1).forEach((internal, index) => {
      const suffix = index + 1;
      data.append(`internal${suffix}`, internal.name);
      data.append(`intcpf${suffix}`, internal.cpf);
      data.append(`type_relationship${suffix}`, internal.type_relationship);
      data.append(`intdate_of_birth${suffix}`, internal.date_of_birth);
      data.append(`mother${suffix}`, internal.mother);
    });

    try {
      const accessToken = localStorage.getItem('accessToken');
      if (!accessToken) {
        toast.error('Sessão expirada. Faça login novamente para enviar.');
        setIsSubmitting(false);
        return;
      }

      const result = await api.post('internals/visitor/familyvisitor/', data, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'multipart/form-data',
        },
        skip401Redirect: true,
      });

      if (result) {
        toast.success('Dados enviados! Acompanhe andamento no e-mail cadastrado .');

        setFormData({
          name: '',
          cpf: '',
          email: '',
          phone_one: '',
          phone_second: '',
          rules: false,
          date_of_birth: '',
          nationality: '',
          naturalness: '',
          internal: '',
          intcpf: '',
          type_relationship: '',
          intdate_of_birth: '',
          mother: '',
          city: '',
          uf: '',
          neighborhood: '',
          public_place: '',
          'Foto 3X4': null,
          'Cedula de identidade ou documento equivalente': null,
          'Cadastro de Pessoa Física (CPF)': null,
          'Certidão de antecedentes criminais estadual': null,
          'Certidão de antecedentes criminais federal': null,
          'Comprovante de residência': null,
          'Certidão de casamento': null,
          'Declaração união estável': null,
          'Prova de mesmo domicílio': null,
          'Outros documentos de comprovação de união': null,
        });
        setAddedInternals([]);
        setStateSearchQuery('');
        setCitySearchQuery('');
        setFilteredStates([]);
        setFilteredCities([]);
        setShouldSearchState(false);
        setShouldSearchCity(false);
        setCurrentStep(1);
      }
    } catch (error) {
      console.error('Erro ao enviar dados', error);
      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        null;
      if (error?.response?.status === 401 && !apiMessage) {
        toast.error('Sessão expirada. Faça login novamente para concluir o cadastro.');
        localStorage.removeItem('accessToken');
        setTimeout(() => {
          window.location.href = '/login';
        }, 1500);
      } else {
        toast.error(apiMessage || 'Erro! verifique os dados');
      }
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container visitante-form-container visitante-cadastro-v2">
        <Titulo
          children={
            <h2>Cadastro visitante</h2>
          }
        />

        <div className="visitante-mode-switch">
          <button
            type="button"
            className={`visitante-mode-btn ${registrationMode === 'visitor' ? 'active' : ''}`}
            onClick={() => setRegistrationMode('visitor')}
          >
            Visitante
          </button>
          <button
            type="button"
            className={`visitante-mode-btn ${registrationMode === 'minor' ? 'active' : ''}`}
            onClick={() => setRegistrationMode('minor')}
          >
            Visitante menor
          </button>
        </div>

        {registrationMode === 'visitor' ? (
          <div className="visitante-form-card">
            <div className="visitante-steps">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className={`visitante-steps-item ${currentStep === step.id ? 'visitante-active' : ''} ${currentStep > step.id ? 'visitante-complete' : ''
                    }`}
                >
                  <span className="visitante-steps-index">
                    {step.id.toString().padStart(2, '0')}
                  </span>
                  <span className="visitante-steps-label">{step.label}</span>
                </div>
              ))}
            </div>

            <form className="visitante-form visitante-form-modern" onSubmit={handleSubmit}>
              {/* Primeiro Step - Informações Pessoais */}
              {currentStep === 1 && (
                <div className="visitante-step">
                  <h2>Informações Pessoais</h2>
                  <div className="form-group">
                    <label>Nome Completo</label>
                    <FormattedInput
                      type="nome"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                    {errors.name && <span className="visitante-error">{errors.name}</span>}
                  </div>

                  <div className='form-group-duplo'>
                    <div className='form-group'>
                      <label>CPF</label>
                      <FormattedInput
                        type="cpf"
                        name="cpf"
                        value={formData.cpf}
                        onChange={handleInputChange}
                      />
                      {errors.cpf && <span className="visitante-error">{errors.cpf}</span>}
                    </div>

                    <div className='form-group'>
                      <label>Data de Nascimento</label>
                      <input
                        type="date"
                        name="date_of_birth"
                        value={formData.date_of_birth}
                        onChange={handleInputChange}
                      />
                      {errors.date_of_birth && <span className="visitante-error">{errors.date_of_birth}</span>}
                    </div>
                  </div>

                  <div className='form-group-duplo'>
                    <div className='form-group'>
                      <label>Nacionalidade</label>
                      <input
                        type="text"
                        name="nationality"
                        value={formData.nationality}
                        onChange={handleInputChange}
                      />
                      {errors.nationality && <span className="visitante-error">{errors.nationality}</span>}
                    </div>

                    <div className='form-group'>
                      <label>Naturalidade</label>
                      <input
                        type="text"
                        name="naturalness"
                        value={formData.naturalness}
                        onChange={handleInputChange}
                      />
                      {errors.naturalness && <span className="visitante-error">{errors.naturalness}</span>}
                    </div>
                  </div>

                  <div className='form-group-duplo'>
                    <div className='form-group'>
                      <label>E-mail</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                      {errors.email && <span className="visitante-error">{errors.email}</span>}
                    </div>

                    <div className='form-group'>
                      <label>Telefone</label>
                      <FormattedInput
                        type="telefone"
                        name="phone_one"
                        value={formData.phone_one}
                        onChange={handleInputChange}
                      />
                      {errors.phone_one && <span className="visitante-error">{errors.phone_one}</span>}
                    </div>
                  </div>
                </div>
              )}

              {/* Segundo Step - Internos Associados */}
              {currentStep === 2 && (
                <div className="visitante-step">
                  <h2>Internos Associados</h2>
                  <div className="form-group internal-result">
                    <label>Nome do interno associado</label>
                    <FormattedInput
                      type="nome"
                      name="internal"
                      value={formData.internal} // Mostra o nome do interno visualmente
                      onChange={handleInternalSearch} // Função de busca de internos
                      autoComplete="off"
                    />

                    {filteredInternals.length > 0 && (
                      <div className="internal-suggestions">
                        {filteredInternals.map((internal, index) => (
                          <div
                            key={internal.id || internal.name || `internal-option-${index}`}
                            onClick={() => handleSelectInternal(internal)}
                          >
                            {internal.name}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className='form-group-duplo'>
                    <div className='form-group'>
                      <label>Nome da mãe</label>
                      <FormattedInput
                        type="nome"
                        name="mother"
                        value={formData.mother}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className='form-group'>
                      <label>
                        Gráu de parentesco <TooltipInfo text="Informe o grau de parentesco do visitante com o interno." />
                      </label>
                      <select
                        name="type_relationship"
                        value={formData.type_relationship}
                        onChange={handleInputChange}
                      >
                        <option value="">Selecione</option>
                        {relationTypes.map((relation) => (
                          <option key={relation.id} value={relation.name}>
                            {relation.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className='form-group-duplo'>
                    <div className='form-group'>
                      <label>CPF do Interno</label>
                      <FormattedInput
                        type="cpf"
                        name="intcpf"
                        value={formData.intcpf}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className='form-group'>
                      <label>Data de Nascimento do Interno</label>
                      <input
                        type="date"
                        name="intdate_of_birth"
                        value={formData.intdate_of_birth}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  {/* Botão para adicionar o interno à lista */}
                  <button className='add-interno-btn' type="button" onClick={handleAddInternal}>
                    Adicionar Interno
                  </button>

                  {errors.internal && <span className="visitante-error">{errors.internal}</span>}

                  {/* Renderizar a tabela de internos adicionados */}
                  <table className="visitante-internal-table">
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th></th>
                        <th>Grau de Parentesco</th>
                        <th>Remover</th>
                      </tr>
                    </thead>
                    {addedInternals.length > 0 && (
                      <tbody>
                        {addedInternals.map((internal, index) => (
                          <tr key={index}>
                            <td>{internal.name}</td>
                            <td></td>
                            <td>{internal.type_relationship}</td>
                            <td>
                              <button className='del-interno-btn ' type="button" onClick={() => handleRemoveInternal(index)}>X</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                  </table>
                </div>
              )}

              {/* Terceiro Step - Endereço */}
              {currentStep === 3 && (
                <div className="visitante-step">
                  <h2>Endereço</h2>
                  <div className='form-group-duplo'>
                    <div className='form-group internal-result'>
                      <label>Estado</label>
                      <input
                        type="text"
                        value={stateSearchQuery}
                        onChange={(e) => handleStateSearch(e.target.value)}
                        placeholder="Digite o estado"
                      />
                      {filteredStates.length > 0 && (
                        <div className="internal-suggestions">
                          {filteredStates.map((state) => (
                            <div
                              key={state.id || state.uf || state.acronym || state.name}
                              onClick={() => selectState(state)}
                            >
                              {state.name} ({state.uf || state.acronym})
                            </div>
                          ))}
                        </div>
                      )}
                      {errors.uf && <span className="visitante-error">{errors.uf}</span>}
                    </div>
                    <div className='form-group internal-result'>
                      <label>Cidade</label>
                      <input
                        type="text"
                        value={citySearchQuery}
                        onChange={(e) => handleCitySearch(e.target.value)}
                        placeholder={formData.uf ? "Digite a cidade" : "Selecione um estado primeiro"}
                        disabled={!formData.uf}
                      />
                      {filteredCities.length > 0 && (
                        <div className="internal-suggestions">
                          {filteredCities.map((city) => (
                            <div key={city.id || city.name} onClick={() => selectCity(city)}>
                              {city.name}
                            </div>
                          ))}
                        </div>
                      )}
                      {errors.city && <span className="visitante-error">{errors.city}</span>}
                    </div>
                  </div>

                  <div className='form-group-duplo'>
                    <div className='form-group'>
                      <label>Bairro</label>
                      <FormattedInput
                        type="nome"
                        name="neighborhood"
                        value={formData.neighborhood}
                        onChange={handleInputChange}
                      />
                      {errors.neighborhood && <span className="visitante-error">{errors.neighborhood}</span>}
                    </div>
                    <div className='form-group'>
                      <label>Logradouro</label>
                      <FormattedInput
                        type="nome"
                        name="public_place"
                        value={formData.public_place}
                        onChange={handleInputChange}
                      />
                      {errors.public_place && <span className="visitante-error">{errors.public_place}</span>}
                    </div>
                  </div>
                </div>
              )}

              {/* Quarto Step - Documentos */}
              {currentStep === 4 && (
                <div className="visitante-step">
                  <h2>Documentos</h2>
                  <div className="documents-section">
                    <div className="">
                      <div className="form-group">
                        <label>Foto legível <span style={{ color: 'red' }}>*</span></label>
                        <input
                          type="file"
                          name="Foto 3X4"
                          accept="image/*"
                          onChange={handleInputChange}
                        />
                        {errors['Foto 3X4'] && <span className="visitante-error">{errors['Foto 3X4']}</span>}
                      </div>

                      <div className="form-group">
                        <label>Cédula de Identidade ou Documento Equivalente <span style={{ color: 'red' }}>*</span></label>
                        <input
                          type="file"
                          name="Cedula de identidade ou documento equivalente"
                          onChange={handleInputChange}
                        />
                        {errors['Cedula de identidade ou documento equivalente'] && <span className="visitante-error">{errors['Cedula de identidade ou documento equivalente']}</span>}
                      </div>

                      <div className="form-group">
                        <label>Cadastro de Pessoa Física (CPF) <span style={{ color: 'red' }}>*</span></label>
                        <input
                          type="file"
                          name="Cadastro de Pessoa Física (CPF)"
                          onChange={handleInputChange}
                        />
                        {errors['Cadastro de Pessoa Física (CPF)'] && <span className="visitante-error">{errors['Cadastro de Pessoa Física (CPF)']}</span>}
                      </div>

                      <div className="form-group">
                        <label>Certidão de Antecedentes Criminais Estadual</label>
                        <input
                          type="file"
                          name="Certidão de antecedentes criminais estadual"
                          onChange={handleInputChange}
                        />
                        {errors['Certidão de antecedentes criminais estadual'] && <span className="visitante-error">{errors['Certidão de antecedentes criminais estadual']}</span>}
                      </div>

                      <div className="form-group">
                        <label>Certidão de Antecedentes Criminais Federal</label>
                        <input
                          type="file"
                          name="Certidão de antecedentes criminais federal"
                          onChange={handleInputChange}
                        />
                        {errors['Certidão de antecedentes criminais federal'] && <span className="visitante-error">{errors['Certidão de antecedentes criminais federal']}</span>}
                      </div>
                      <div className="form-group">
                        <label>Comprovante de Residência</label>
                        <input
                          type="file"
                          name="Comprovante de residência"
                          onChange={handleInputChange}
                        />
                        <br></br>
                        {errors['Comprovante de residência'] && <span className="visitante-error">{errors['Comprovante de residência']}</span>}
                      </div>
                    </div>
                    <div className="">
                      <h4 className='h4-title'>Em caso de Conjuge ou União estável</h4>
                      <div className="form-group">
                        <label>Certidão de casamento</label>
                        <input
                          type="file"
                          name="Certidão de casamento"
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="form-group">
                        <label>Declaração união estável</label>
                        <input
                          type="file"
                          name="Declaração união estável"
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="form-group">
                        <label>Prova de mesmo domicílio</label>
                        <input
                          type="file"
                          name="Prova de mesmo domicílio"
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="form-group">
                        <label>Outros documentos de comprovação de união</label>
                        <input
                          type="file"
                          name="Outros documentos de comprovação de união"
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}


              {/* Quinto Step - Declaração */}
              {currentStep === 5 && (
                <div className="visitante-step">
                  <h2>Declaração</h2>
                  <p>
                    <strong>DECLARO</strong>, para os devidos fins de direito, sob as penas da lei, que as informações prestadas neste cadastro, enquanto visitante de pessoa privada de liberdade custodiada no Sistema Penitenciário do Estado do Piauí, são verdadeiras e autênticas (fieis a verdade e condizente com a realidade dos fatos).
                  </p>
                  <br />
                  <p>
                    <strong>ASSUMO</strong>, através desse documento que a falsidade dessa Declaração configura crime previsto no Código Penal Brasileiro, passível de apuração na forma da Lei bem como pode ser enquadrada como litigância de Má-fé. Nada mais a declarar, e ciente das responsabilidades das declarações prestadas, firmo a presente.
                  </p>
                  <br />
                  <label>
                    <input
                      type="checkbox"
                      name="rules"
                      checked={formData.rules}
                      onChange={handleInputChange}
                    />
                    Eu concordo com os termos.
                  </label>
                  <br></br>
                  {errors.rules && <span className="visitante-error">{errors.rules}</span>}
                </div>
              )}

              {/* Sexto Step - Confirmação */}
              {currentStep === 6 && (
                <div className="visitante-step">
                  <h2>Confirmação</h2>
                  <table className="visitante-summary-table">
                    <tbody>
                      <tr>
                        <td><strong>Nome:</strong></td>
                        <td>{formData.name}</td>
                      </tr>
                      <tr>
                        <td><strong>Email:</strong></td>
                        <td>{formData.email}</td>
                      </tr>
                      <tr>
                        <td><strong>CPF:</strong></td>
                        <td>{formData.cpf}</td>
                      </tr>
                      <tr>
                        <td><strong>Telefone:</strong></td>
                        <td>{formData.phone_one}</td>
                      </tr>
                      <tr>
                        <td><strong>Cidade:</strong></td>
                        <td>{formData.city}</td>
                      </tr>
                      <tr>
                        <td><strong>Estado:</strong></td>
                        <td>{stateSearchQuery || formData.uf}</td>
                      </tr>
                      <tr>
                        <td><strong>Bairro:</strong></td>
                        <td>{formData.neighborhood}</td>
                      </tr>
                      <tr>
                        <td><strong>Logradouro:</strong></td>
                        <td>{formData.public_place}</td>
                      </tr>
                      <tr>
                        <td><strong>Foto 3X4:</strong></td>
                        <td>{formData['Foto 3X4'] ? formData['Foto 3X4'].name : 'Não enviado'}</td>
                      </tr>
                      <tr>
                        <td><strong>Cedula de identidade ou documento equivalente:</strong></td>
                        <td>{formData['Cedula de identidade ou documento equivalente'] ? formData['Cedula de identidade ou documento equivalente'].name : 'Não enviado'}</td>
                      </tr>
                      <tr>
                        <td><strong>Comprovante de Residência:</strong></td>
                        <td>{formData['Comprovante de residência'] ? formData['Comprovante de residência'].name : 'Não enviado'}</td>
                      </tr>
                      <tr>
                        <td><strong>Cadastro de Pessoa Física (CPF):</strong></td>
                        <td>{formData['Cadastro de Pessoa Física (CPF)'] ? formData['Cadastro de Pessoa Física (CPF)'].name : 'Não enviado'}</td>
                      </tr>
                      <tr>
                        <td><strong>Certidão de antecedentes criminais estadual:</strong></td>
                        <td>{formData['Certidão de antecedentes criminais estadual'] ? formData['Certidão de antecedentes criminais estadual'].name : 'Não enviado'}</td>
                      </tr>
                      <tr>
                        <td><strong>Certidão de antecedentes criminais federal:</strong></td>
                        <td>{formData['Certidão de antecedentes criminais federal'] ? formData['Certidão de antecedentes criminais federal'].name : 'Não enviado'}</td>
                      </tr>
                      <tr>
                        <td><strong>Concordo com os termos e condições:</strong></td>
                        <td>{formData.rules ? 'Sim' : 'Não'}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}


              <div className="visitante-buttons">
                {currentStep === 1 && (
                  <button type="button" className="visitante-btn-secondary" disabled onClick={prevStep}>Voltar</button>
                )}
                {currentStep > 1 && (
                  <button type="button" className="visitante-btn-secondary" onClick={prevStep}>Voltar</button>
                )}
                {currentStep < 6 && (
                  <button type="button" className="visitante-btn-primary" onClick={nextStep}>Próximo</button>
                )}
                {currentStep === 6 && (
                  <button
                    type="submit"
                    className={`visitante-btn-primary ${isSubmitting ? 'btn-disabled' : ''}`}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Enviando...' : 'Enviar'}
                  </button>
                )}
              </div>
            </form>
          </div>
        ) : (
          <div className="visitante-form-card">
            <CadastroMenorForm
              listInternals={listInternals}
              buildUnitReadParams={buildUnitReadParams}
              relationTypes={relationTypes}
              listState={listState}
              listCity={listCity}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CadastroVisitante;
